<template>
  <tr>
    <td>
      {{ item.name }}
    </td>
    <td>
      <div
        v-if="
          $userCheckAccess({
            abilities: 'edit_client_addresses',
          })
        "
        class="buttons"
      >
        <WorkRegionModal :create="false" :id="item.id" />
        <DeleteModal
          :item="item"
          :text="
            localStorage.translations.pages['setting-region']['dialog_delete']['udalit-region'] +
            ' ' +
            item.name
          "
        />
      </div>
    </td>
  </tr>
</template>

<script>
import WorkRegionModal from 'components/setting/workRegion/WorkRegionModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'WorkRegionTableItem',
  components: { WorkRegionModal, DeleteModal },
  props: ['item'],
}
</script>
